import { FC } from 'react'
import {
  WalletModalProvider,
  WalletMultiButton,
} from '@solana/wallet-adapter-react-ui'
import { useWallet } from '@solana/wallet-adapter-react'

export const Wallet: FC = () => {
  const { publicKey } = useWallet()

  return (
    <WalletModalProvider featuredWallets={4} logo={'/Bananas-90px.png'}>
      <WalletMultiButton
        children={publicKey ? null : 'Connect Wallet'}
        className="Connect-wallet-button"
      />
    </WalletModalProvider>
  )
}
